import moment, { Moment } from 'moment'

// set data start date to include one month either side of the 2 "on screen" months
export const getInitialStartDate = (
  startDate: string | Moment,
  offsetInMonths: number = 1
) => moment(startDate).subtract(offsetInMonths, 'month').startOf('month')
export const getInitialEndDate = (
  startDate: string | Moment,
  offsetInMonths: number = 2
) => moment(startDate).add(offsetInMonths, 'months').endOf('month')

export const getInitialDataBounds = (
  startDate?: string | Moment,
  offscreenMonthsEitherSide: number = 1
) => {
  if (startDate == null || moment(startDate).isValid() !== true) {
    // eslint-disable-next-line no-param-reassign
    startDate = moment()
  }

  const startDateOffset = offscreenMonthsEitherSide
  const endDateOffset = offscreenMonthsEitherSide + 1 // there are 2 months on screen at any one time -- need to shift by 1
  return {
    initialDataStartDate: getInitialStartDate(startDate, startDateOffset),
    initialDataEndDate: getInitialEndDate(startDate, endDateOffset),
  }
}

interface MoveDataWindowArgs {
  dataStartDate: string | Moment
  dataEndDate: string | Moment
  shiftByMonths?: number
}

export const moveDataWindowForward = ({
  dataStartDate,
  dataEndDate,
  shiftByMonths = 1,
}: MoveDataWindowArgs) => {
  const nextDataStartDate = moment(dataStartDate)
    .add(shiftByMonths, 'month')
    .startOf('month')
  const nextDataEndDate = moment(dataEndDate)
    .add(shiftByMonths, 'month')
    .endOf('month')

  return {
    nextDataStartDate,
    nextDataEndDate,
  }
}

export const moveDataWindowBackwards = ({
  dataStartDate,
  dataEndDate,
  shiftByMonths = 1,
}: MoveDataWindowArgs) => {
  const nextDataStartDate = moment(dataStartDate)
    .subtract(shiftByMonths, 'month')
    .startOf('month')
  const nextDataEndDate = moment(dataEndDate)
    .subtract(shiftByMonths, 'month')
    .endOf('month')

  return {
    nextDataStartDate,
    nextDataEndDate,
  }
}
